// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ApplicationSecuritySignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ApplicationSecuritySignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M6.916 12.257a9.6 9.6 0 0 0 1.797-.492 11 11 0 0 1-.458-1.245A10.5 10.5 0 0 1 7.857 6.3 12 12 0 0 0 6.13 5.894a2.02 2.02 0 0 0-1.668.48A1.56 1.56 0 0 0 4.016 7.04a10.2 10.2 0 0 0 .682 4.324 2.26 2.26 0 0 0 2.218.894m8.884-7.72a1.1 1.1 0 0 0-.671-.713l-.28-.107a2.68 2.68 0 0 1 .232 1.77c-.402 1.87-1.38 3.566-2.826 4.904a10.2 10.2 0 0 1-5.217 2.56A3.05 3.05 0 0 1 5.38 12.77c.886 1.52 2.295 3.045 4.48 4.405a.5.5 0 0 0 .527 0C17.605 12.637 16.36 6.378 15.8 4.538M6.24 5.2c2.089.329 4.03 1.168 5.62 2.42a11 11 0 0 1 1.07.965 8.6 8.6 0 0 0 1.468-3.244c.185-.858-.225-1.711-.981-2.17L10.56 2.08a1.2 1.2 0 0 0-.867 0L5.115 3.82a1.12 1.12 0 0 0-.671.718 10 10 0 0 0-.277 1.167A2.74 2.74 0 0 1 6.241 5.2" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ApplicationSecuritySignetIcon = /* @__PURE__ */ Object.assign(
  ApplicationSecuritySignetIconComponent,
  { displayName: 'ApplicationSecuritySignetIcon' },
);
